var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { AccordionTitle, List, Grid, GridColumn, ListItem } from 'telia-front-react';
import { observer } from 'mobx-react';
import React, { Component } from 'react';
import customerIdAsKey from '../auth/customerIdAsKey';
import { getAddressLabel } from '../util/AddressUtil';
import { injectStores } from '../util/StoresUtil';
let PersonInfoHeader = class PersonInfoHeader extends Component {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "personInfoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "personAddressStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "translateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    componentDidMount() {
        this.personInfoStore.loadPersonInfo();
        this.personAddressStore.loadPersonAddress();
    }
    render() {
        const { translate } = this.translateStore;
        const person = this.personInfoStore.personInfo || {};
        const address = this.personAddressStore.primeContactAddress && this.personAddressStore.primeContactAddress.address;
        return (React.createElement(Grid, { gutter: "none", align: ['middle-xs'] },
            React.createElement(GridColumn, null,
                React.createElement(AccordionTitle, { className: "h3 text-bold" }, translate('personHeaderInfo.title'))),
            React.createElement(GridColumn, null,
                React.createElement(List, { bordered: true, direction: "inline", type: "unstyled" },
                    React.createElement(ListItem, null, person.displayName),
                    React.createElement(ListItem, null, address ? getAddressLabel(address) : '-')))));
    }
};
PersonInfoHeader = __decorate([
    customerIdAsKey,
    injectStores,
    observer
], PersonInfoHeader);
export default PersonInfoHeader;
